import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenericBlockScreenService {
  private modalElement: HTMLDialogElement | null = null;

  public createBlockScreen(props: {
    title?: string;
    description: string;
  }): void {
    if (this.modalElement) return;

    const dialog = this.buildDialog();

    if (props.title) {
      dialog.appendChild(this.buildTitle(props.title));
    }

    dialog.appendChild(this.buildDescription(props.description));

    document.body.appendChild(dialog);
    dialog.showModal();

    this.modalElement = dialog;
  }

  public hideBlockScreen(): void {
    if (!this.modalElement) return;

    this.modalElement.close();
    this.modalElement.remove();
    this.modalElement = null;
  }

  // ------------------------
  // Internal Element Builders
  // ------------------------

  private reset(element: HTMLElement): void {
    element.style.all = 'unset';
  }

  private buildDialog(): HTMLDialogElement {
    const dialog = document.createElement('dialog');

    // Inject global backdrop CSS once
    if (!document.getElementById('dialog-global-backdrop-style')) {
      const style = document.createElement('style');
      style.id = 'dialog-global-backdrop-style';
      style.innerHTML = `
        dialog::backdrop {
          background: rgba(0, 0, 0, 0.91);
          backdrop-filter: blur(3px);
        }
      `;
      document.head.appendChild(style);
    }

    Object.assign(dialog.style, {
      padding: '2rem',
      border: 'none',
      borderRadius: '0.75rem',
      boxShadow: '0 0.5rem 2rem rgba(0, 0, 0, 0.15)',
      width: '30.25rem',
      maxWidth: 'calc(100vw - 3rem)',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: '#1A1A1A',
      backgroundColor: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      textAlign: 'left',
      boxSizing: 'border-box',
    });

    return dialog;
  }

  private buildTitle(text: string): HTMLHeadingElement {
    const title = document.createElement('h2');
    this.reset(title);
    title.innerText = text;

    Object.assign(title.style, {
      fontSize: '1.5rem',
      fontWeight: '600',
      margin: '0',
      color: '#1A1A1A',
    });

    return title;
  }

  private buildDescription(text: string): HTMLParagraphElement {
    const p = document.createElement('p');
    this.reset(p);
    p.innerText = text;

    Object.assign(p.style, {
      fontSize: '1rem',
      lineHeight: '1.6',
      textAlign: 'justify',
    });

    return p;
  }
}
